import Gumshoe from 'gumshoejs'
import jquery from 'jquery'
import SmoothScroll from 'smooth-scroll'
import stickybits from 'stickybits'
import { gsap as Gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { tns } from 'tiny-slider/src/tiny-slider'
import Typed from 'typed.js'
import Cookies from 'cookies-js'

(function ($) {
  $(document).on('turbolinks:load', function () {
    /* eslint-disable no-new */
    new Gumshoe('.br-sidebar-nav a', {
      navClass: 'navlinks__item--active',
      offset: 120
    })

    /* eslint-disable no-new */
    new SmoothScroll('a[href*="#"]', {
      offset: 150,
      ignore: '[data-scroll-ignore]'
    })

    if (window.location.hash) {
      $('html, body').animate({ scrollTop: $(window.location.hash).offset().top - 120 }, 200)
    }

    $('button[data-community-type]').click(function (e) {
      const opportunityType = $(this).attr('data-community-type')

      Cookies.set('organization_type', opportunityType)

      setTimeout(() => {
        var scrollPosition

        document.addEventListener('turbolinks:load', function () {
          if (scrollPosition) {
            window.scrollTo.apply(window, scrollPosition)
            scrollPosition = null
          }
        }, false)

        scrollPosition = [window.scrollX, window.scrollY]
        window.Turbolinks.visit(window.location, { action: 'replace' })
      }, 200)
    })

    if ($('.autotype').length) {
      /* auto typing */
      new Typed('.autotype', {
        strings: [
          'best practices.',
          'shared experiences.',
          'pressing questions.',
          'workplace meaning.'
        ],
        stringsElement: null,
        typeSpeed: 50,
        startDelay: 0,
        backDelay: 2000,
        backSpeed: 30,
        smartBackspace: true,
        loop: true
      })
    }

    const handleSupportHashChange = (hash) => {
      $('.br-faq__item').removeClass('br-faq__item--active')
      $('.br-faq__details__foot').show()

      $(hash)
        .removeClass('br-faq__item--truncate')
        .addClass('br-faq__item--active')

      $(hash)
        .find('.br-faq__details__foot')
        .hide()
    }

    $('.br-faq__details__foot a').click(function () {
      const href = $(this).attr('href')

      handleSupportHashChange(href)
    })

    if (window.location.hash) {
      handleSupportHashChange(window.location.hash)
    }

    if (window.location.search && window.location.search === '?action=play-video') {
      $('#play-video').click()
    }

    /* sidebar */
    stickybits('.br-sidebar-nav', {
      stickyBitStickyOffset: 120
    })

    var body = $('body')
    var mobileNav = $('.br-mobile-nav')
    var showMobileNav = $('.js-show-branding-mobile-nav')
    var closeMobileNav = $('.js-close-branding-mobile-nav')

    /*
     toggle mobile nav
     */
    showMobileNav.on('click', function () {
      mobileNav.addClass('br-mobile-nav--active')
      body.addClass('u-no-scroll-y')
    })

    closeMobileNav.on('click', function () {
      mobileNav.removeClass('br-mobile-nav--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     toggle mega dropdown
     */
    $('.js-toggle-dropdown').on({
      click: function (e) {
        $(this)
          .parents('.br-topbar')
          .removeClass('br-topbar--active')
          .addClass('br-topbar--active')
        $(this)
          .parents('.navlinks')
          .find('.navlinks__item')
          .removeClass('navlinks__item--active')
        $(this)
          .parents('.navlinks')
          .siblings()
          .find('.navlinks__item')
          .removeClass('navlinks__item--active')
        $(this)
          .parents('.navlinks__item')
          .addClass('navlinks__item--active')
          .focus()
        e.preventDefault()
      },
      keydown: function (e) {
        if (e.which === 27) {
          $(this)
            .parents('.br-topbar')
            .removeClass('br-topbar--active')
            .addClass('br-topbar--active')
          $(this)
            .parents('.navlinks')
            .find('.navlinks__item')
            .removeClass('navlinks__item--active')
          $(this)
            .parents('.navlinks')
            .siblings()
            .find('.navlinks__item')
            .removeClass('navlinks__item--active')
          $(this)
            .parents('.navlinks__item')
            .addClass('navlinks__item--active')
            .focus()
          e.preventDefault()
        }
      },
      focusout: function (e) {
        if (!e.relatedTarget) {
          $(this)
            .parents('.br-topbar')
            .removeClass('br-topbar--active')
          $(this)
            .parents('.navlinks')
            .find('.navlinks__item')
            .removeClass('navlinks__item--active')
          e.preventDefault()
        }
      }
    })

    /*
     toggle mega dropdown
     */
    $('.hook-link').on({
      click: function (e) {
        $(this)
          .parents('.br-topbar')
          .removeClass('br-topbar--active')
        $(this)
          .parents('.navlinks')
          .find('.navlinks__item')
          .removeClass('navlinks__item--active')
      },
      keydown: function (e) {
        if (e.which === 27) {
          $(this)
            .parents('.br-topbar')
            .removeClass('br-topbar--active')
          $(this)
          .parents('.navlinks')
          .find('.navlinks__item')
          .removeClass('navlinks__item--active')
        }
      },
      focusout: function (e) {

      }
    })

    /*
     how it works toggle carrds
     */
    $('.br-description-cards__item').on({
      click: function (e) {
        $(this).toggleClass('br-description-cards__item--active')
      },
      keydown: function (e) {
        if (e.which === 27) {
          $(this).toggleClass('br-description-cards__item--active')
        }
      },
      focusout: function (e) {
        if (!e.relatedTarget) {
          $(this).toggleClass('br-description-cards__item--active')
        }
      }
    })

    /*
     show guide on 700px
     */
    $(window).scroll(function () {
      if ($(window).scrollTop() > 768) {
        $('.br-guide').addClass('br-guide--active')
      } else {
        $('.br-guide').removeClass('br-guide--active')
      }
    })

    /*
     topbar transition
     */
    $(window).scroll(function () {
      if ($(window).scrollTop() > 10) {
        $('.br-topbar').addClass('br-topbar--overlap')
      } else {
        $('.br-topbar').removeClass('br-topbar--overlap')
      }
    })

    Gsap.registerPlugin(ScrollTrigger)

    /*
     watercooler animation
     */
    // const demo = $('.br-product-slide__demo')
    // const p1tl = Gsap.timeline({ paused: true })
    // const p2tl = Gsap.timeline({ paused: true })
    // const p3tl = Gsap.timeline({ paused: true })
    // const p4tl = Gsap.timeline({ paused: true })
    // const p5tl = Gsap.timeline({ paused: true })
    // const p6tl = Gsap.timeline({ paused: true })
    //
    // $('.br-product-slide__process-b').hide()
    // $('.br-product-slide__process-c').hide()
    // $('.br-product-slide__process-d').hide()
    // $('.br-product-slide__process-e').hide()
    // $('.br-product-slide__process-f').hide()
    //
    // p1tl.from('.br-product-slide__process-a__component-a', { y: 50, autoAlpha: 0 })
    //     .from('.br-product-slide__process-a__component-b', { y: 50, autoAlpha: 0 })
    //
    // ScrollTrigger.create({
    //   animation: p1tl,
    //   trigger: demo,
    //   start: 'top 30%',
    //   onEnter: () => p1tl.play()
    // })
    //
    // ScrollTrigger.create({
    //   animation: p2tl,
    //   start: 'top 30%'
    // })
    //
    // ScrollTrigger.create({
    //   animation: p3tl,
    //   start: 'top 30%'
    // })
    //
    // ScrollTrigger.create({
    //   animation: p4tl,
    //   start: 'top 30%'
    // })
    //
    // ScrollTrigger.create({
    //   animation: p5tl,
    //   start: 'top 30%'
    // })
    //
    // ScrollTrigger.create({
    //   animation: p6tl,
    //   start: 'top 30%'
    // })
    //
    // $('.pb-trigger').on({
    //   click: function (e) {
    //     $('.br-product-slide__process-b').show()
    //     $('.br-product-slide__process-c').hide()
    //     $('.br-product-slide__process-d').hide()
    //     $('.br-product-slide__process-e').hide()
    //     $('.br-product-slide__process-f').hide()
    //     p2tl.fromTo('.br-product-slide__process-b__overlay', { autoAlpha: 0 }, { autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-b__component-a', { autoAlpha: 0 }, { autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-b__dialog', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    //     e.preventDefault()
    //   }
    // })
    //
    // $('.pc-trigger').on({
    //   click: function (e) {
    //     $('.br-product-slide__process-b').hide()
    //     $('.br-product-slide__process-c').show()
    //     $('.br-product-slide__process-d').hide()
    //     $('.br-product-slide__process-e').hide()
    //     $('.br-product-slide__process-f').hide()
    //     p3tl.fromTo('.br-product-slide__process-c__overlay', { autoAlpha: 0 }, { autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-c__component-a', { x: -30, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-c__dialog', { x: -30, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    //     e.preventDefault()
    //   }
    // })
    //
    // $('.pd-trigger').on({
    //   click: function (e) {
    //     $('.br-product-slide__process-b').hide()
    //     $('.br-product-slide__process-c').hide()
    //     $('.br-product-slide__process-d').show()
    //     $('.br-product-slide__process-e').hide()
    //     $('.br-product-slide__process-f').hide()
    //     p4tl.fromTo('.br-product-slide__process-d__overlay', { autoAlpha: 0 }, { autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-d__component-a', { autoAlpha: 0 }, { autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-d__dialog', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    //     e.preventDefault()
    //   }
    // })
    //
    // $('.pe-trigger').on({
    //   click: function (e) {
    //     $('.br-product-slide__process-b').hide()
    //     $('.br-product-slide__process-c').hide()
    //     $('.br-product-slide__process-d').hide()
    //     $('.br-product-slide__process-e').show()
    //     $('.br-product-slide__process-f').hide()
    //     p5tl.fromTo('.br-product-slide__process-e__overlay', { autoAlpha: 0 }, { autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-e__component-a', { autoAlpha: 0 }, { autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-e__dialog', { x: -30, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    //     e.preventDefault()
    //   }
    // })
    //
    // $('.pf-trigger').on({
    //   click: function (e) {
    //     $('.br-product-slide__process-b').hide()
    //     $('.br-product-slide__process-c').hide()
    //     $('.br-product-slide__process-d').hide()
    //     $('.br-product-slide__process-e').hide()
    //     $('.br-product-slide__process-f').show()
    //     p6tl.fromTo('.br-product-slide__process-f__component-b', 1, { y: 0 }, { y: -110 })
    //         .fromTo('.br-product-slide__process-f__component-c', 0.2, { autoAlpha: 0 }, { autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-f__overlay', { autoAlpha: 0 }, { delay: 1, autoAlpha: 1 })
    //         .fromTo('.br-product-slide__process-f__component-d', { x: -30, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    //     e.preventDefault()
    //   }
    // })

    /*
     landing animation
     */
    new Gsap.from('.gsap-landing-hero', {
      duration: 0.5,
      y: '50px',
      autoAlpha: 0,
      ease: 'ease-in-out',
      scrollTrigger: {
        trigger: '.gsap-landing-hero',
        // markers: true,
        start: 'top 65%',
        end: 'bottom 35%'
      }
    })

    new Gsap.to('.br-hero__animated-image__phone-content', {
      duration: 4,
      y: '-595',
      ease: 'linear',
      scrollTrigger: {
        trigger: '.gsap-landing-hero',
        scrub: 1,
        start: 'top 40%',
        end: 'bottom 60%'
      }
    })

    new Gsap.from('.gsap-solutions-hero', {
      duration: 0.5,
      x: '-100px',
      autoAlpha: 0,
      ease: 'ease-in-out',
      scrollTrigger: {
        trigger: '.gsap-solutions-hero',
        // markers: true,
        start: 'top 85%',
        end: 'bottom 15%'
      }
    })

    new Gsap.from('.gsap-products-hero-c', {
      duration: 0.5,
      x: '-100px',
      autoAlpha: 0,
      ease: 'ease-in-out',
      scrollTrigger: {
        trigger: '.gsap-products-hero-c',
        // markers: true,
        start: 'top 75%',
        end: 'bottom 25%'
      }
    })

    new Gsap.from('.gsap-products-hero-d', {
      duration: 0.5,
      x: '100px',
      autoAlpha: 0,
      ease: 'ease-in-out',
      scrollTrigger: {
        trigger: '.gsap-products-hero-d',
        // markers: true,
        start: 'top 75%',
        end: 'bottom 25%'
      }
    })

    if ($('.br-clients__featured-list').length) {
      tns({
        container: '.br-clients__featured-list',
        controls: true,
        controlsContainer: '.br-clients__featured-list__controls',
        prevButton: '.br-clients__featured-list__controls__prev',
        nextButton: '.br-clients__featured-list__controls__next',
        nav: false,
        navContainer: '.br-clients__featured-list__nav',
        autoplay: false,
        loop: true,
        speed: 300,
        mouseDrag: true,
        startIndex: 1,
        items: 1,
        edgePadding: 0,
        gutter: 0,
        responsive: {
          900: {
            edgePadding: 70,
            gutter: 40,
            items: 3
          }
        }
      })
    }

    if ($('.br-quote__list').length) {
      tns({
        container: '.br-quote__list',
        controls: true,
        controlsContainer: '.br-quote__controls',
        prevButton: '.br-quote__controls__prev',
        nextButton: '.br-quote__controls__next',
        nav: false,
        navContainer: '.br-quote__nav',
        autoplay: false,
        loop: true,
        speed: 300,
        mouseDrag: true,
        startIndex: 1,
        items: 1,
        edgePadding: 70,
        gutter: 0,
        responsive: {
          900: {
            gutter: 40
          }
        }
      })
    }

    if ($('.br-header-slide__list').length) {
      var headerSlider = tns({
        container: '.br-header-slide__list',
        controls: false,
        controlsContainer: '.br-header-slide__controls',
        prevButton: '.br-header-slide__controls__prev',
        nextButton: '.br-header-slide__controls__next',
        nav: true,
        navContainer: '.br-header-slide__nav',
        autoplay: false,
        autoplayButtonOutput: false,
        loop: true,
        speed: 300,
        mouseDrag: true,
        startIndex: 0,
        items: 1,
        edgePadding: 70,
        gutter: 0,
        responsive: {
          900: {
            gutter: 40
          }
        }
      })

      $('body').on('click', '.button--slider', function () {
        const index = $(this).attr('data-slider-index')

        headerSlider.goTo((index))
      })
    }
  })
})(jquery)
